import React from 'react'

export default function SideBar() {
    return (
        <div className='flex flex-col gap-3'>

            <img
                className='w-full rounded-xl object-cover max-h-[15rem] max-w-[15rem] px-2 mx-auto'
                src='/hossam.jpg'
                alt='Hossam Hatem'
            />

            <div className='flex flex-col items-center'>
                <h2 className='font-bold text-2xl text-[#19284D]'>
                    <a href='https://www.linkedin.com/in/hossam-hatem' target='_blank' rel='noreferrer'>
                        Hossam Hatem
                    </a>
                </h2>
                <p className='bg-[#EFF0F5] px-4 py-2 rounded-md w-fit font-semibold text-[#2184E3] mt-2'>Software Engineer</p>
            </div>

            <div className='bg-[#949EB1] w-[95%] h-[1.5px] mx-auto my-3'></div>

            <div className='flex flex-col gap-5 mx-2'>

                <div className='flex flex-row gap-3'>
                    <div className='flex items-center'>
                        <div className='bg-[#E8EBF0] p-2 rounded-md h-fit'>{emailIcon}</div>
                    </div>
                    <div className='overflow-auto'>
                        <p className='text-[#647590] text-[0.9rem]'>EMAIL</p>
                        <p className='text-[#19284D] font-medium'>hosam.hatem222@gmail.com</p>
                    </div>
                </div>

                <div className='flex flex-row gap-3'>
                    <div className='flex items-center'>
                        <div className='bg-[#E8EBF0] p-2 rounded-md h-fit'>{phoneIcon}</div>
                    </div>
                    <div className=''>
                        <p className='text-[#647590] text-[0.9rem]'>PHONE</p>
                        <p className='text-[#19284D] font-medium'>+201028221247</p>
                    </div>
                </div>

                <div className='flex flex-row gap-3'>
                    <div className='flex items-center'>
                        <div className='bg-[#E8EBF0] p-2 rounded-md h-fit'>{locatonIcon}</div>
                    </div>
                    <div className=''>
                        <p className='text-[#647590] text-[0.9rem]'>LOCATION</p>
                        <p className='text-[#19284D] font-medium'>Cairo, Egypt</p>
                    </div>
                </div>

            </div>

            <a
                className='bg-[#EEEFF4] rounded-md mt-5 px-5 py-3 mx-auto text-[#2184E3] flex flex-row gap-2 font-semibold shadow-md hover:shadow-lg'
                href='https://drive.google.com/drive/folders/14NTxvkQjQT5UHQVrScVdG5ByEAJWjO2O'
                target='_blank'
                rel='noreferrer'
            >
                Download CV {downloadIcon}
            </a>

        </div>
    )
}


const emailIcon = <svg width="17" height="14" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15 1.5C15 0.675 14.325 0 13.5 0H1.5C0.675 0 0 0.675 0 1.5V10.5C0 11.325 0.675 12 1.5 12H13.5C14.325 12 15 11.325 15 10.5V1.5ZM13.5 1.5L7.5 5.25L1.5 1.5H13.5ZM13.5 10.5H1.5V3L7.5 6.75L13.5 3V10.5Z" fill="#2184E3" />
</svg>

const phoneIcon = <svg width="14" height="18" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.26923 0H1.73077C1.27174 0 0.831513 0.191558 0.506931 0.532533C0.182348 0.873508 0 1.33597 0 1.81818V14.1818C0 14.664 0.182348 15.1265 0.506931 15.4675C0.831513 15.8084 1.27174 16 1.73077 16H7.26923C7.72826 16 8.16849 15.8084 8.49307 15.4675C8.81765 15.1265 9 14.664 9 14.1818V1.81818C9 1.33597 8.81765 0.873508 8.49307 0.532533C8.16849 0.191558 7.72826 0 7.26923 0ZM4.5 15.2727C3.92538 15.2727 3.46154 14.7855 3.46154 14.1818C3.46154 13.5782 3.92538 13.0909 4.5 13.0909C5.07462 13.0909 5.53846 13.5782 5.53846 14.1818C5.53846 14.7855 5.07462 15.2727 4.5 15.2727ZM7.61539 12.3636H1.38462V2.18182H7.61539V12.3636Z" fill="#2184E3" />
</svg>

const locatonIcon = <svg width="15" height="17" viewBox="0 0 10 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5 0C2.23571 0 0 2.3475 0 5.25C0 9.1875 5 15 5 15C5 15 10 9.1875 10 5.25C10 2.3475 7.76429 0 5 0ZM5 7.125C4.5264 7.125 4.0722 6.92746 3.73731 6.57583C3.40242 6.22419 3.21429 5.74728 3.21429 5.25C3.21429 4.75272 3.40242 4.27581 3.73731 3.92417C4.0722 3.57254 4.5264 3.375 5 3.375C5.4736 3.375 5.9278 3.57254 6.26269 3.92417C6.59758 4.27581 6.78571 4.75272 6.78571 5.25C6.78571 5.74728 6.59758 6.22419 6.26269 6.57583C5.9278 6.92746 5.4736 7.125 5 7.125Z" fill="#2184E3" />
</svg>

const downloadIcon = <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17.5 13.75V17.5H2.5V13.75H0V17.5C0 18.875 1.125 20 2.5 20H17.5C18.875 20 20 18.875 20 17.5V13.75H17.5ZM16.25 8.75L14.4875 6.9875L11.25 10.2125V0H8.75V10.2125L5.5125 6.9875L3.75 8.75L10 15L16.25 8.75Z" fill="#2184E3"/>
</svg>

